<template>
    <CommandActionEditor v-if="action.type === 'command'" :node="node" :handler="handler"
        :action="action" :handlers="handlers" :categories="commandCategories" @change="$emit('change')" />
    <TemplateVisibilityActionEditor v-else-if="action.type === 'templateVisibility'"
        :action="action" :template-targets="templateTargets" @change="$emit('change')" />
    <SetObjectPropertyActionEditor v-else-if="action.type === 'setObjectProperty'"
        :node="node" :handler="handler" :action="action" :targets="targets" @change="$emit('change')" />
    <Model3dLightActionEditor v-else-if="action.type === 'model3dLight'"
        :node="node" :handler="handler" :action="action" :targets="targets" @change="$emit('change')" />
    <GpioEntityActionEditor v-else-if="action.type === 'gpioEntity'"
        :node="node" :handler="handler" :action="action" :nested="nested"
        :settings="settings" :metadata="gpioMetadata" @change="$emit('change')" />
</template>

<script setup>
import CommandActionEditor from './CommandActionEditor.vue';
import TemplateVisibilityActionEditor from './TemplateVisibilityActionEditor.vue';
import SetObjectPropertyActionEditor from './SetObjectPropertyActionEditor.vue';
import Model3dLightActionEditor from './Model3dLightActionEditor.vue';
import GpioEntityActionEditor from './GpioEntityActionEditor.vue';
defineProps({
    node: Object, handler: Object, action: Object, targets: Array, templateTargets: Array,
    settings: Object, gpioMetadata: Object, handlers: { type: Array, default: null },
    commandCategories: { type: Array, default: null },
    // The action runs behind a condition or switch (Logic view).
    nested: { type: Boolean, default: false },
});
defineEmits(['change']);
</script>
